import React, { useState } from 'react';
import { ProductsData } from '../data/products-data'; // Veriyi import ediyoruz
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion'; // Framer Motion import

const HeaderDeskop = ({ toggle, setToggle }) => {
  const [isSystemsMenuOpen, setIsSystemsMenuOpen] = useState(false); // SİSTEMLER dropdown aç/kapat durumu
  const [openCategoryIndex, setOpenCategoryIndex] = useState(null); // Hangi kategori açık, bunu tutar
  const location = useLocation(); // Şu anki URL'i alır
  const toggleSystemsMenu = () => {
    setIsSystemsMenuOpen(!isSystemsMenuOpen); // SİSTEMLER dropdown aç/kapat
  };

  const toggleCategory = (index) => {
    setOpenCategoryIndex(openCategoryIndex === index ? null : index); // Kategoriyi aç/kapat
  };

  // Aktif link kontrol fonksiyonu
  const isActive = (url) => {
    return location.pathname === url
      ? 'text-turkuaz-blue'
      : 'text-gray-700 hover:scale-105 transition-all duration-300';
  };

  return (
    <header className="relative z-50 col-span-2 overflow-hidden">
      <nav className="flex justify-center items-center w-full ">
        {/* Diğer menü başlıkları */}
        <div className="flex justify-center w-full space-x-5 relative">
          <Link to="/" className={`${isActive('/')} text-sm`}>ANASAYFA</Link>
          <Link to="/hakkimizda" className={`${isActive('/hakkimizda')} text-sm`}>HAKKIMIZDA</Link>

          {/* Dropdown container with relative positioning */}
          <div className="relative inline-block">
            <button
              onClick={toggleSystemsMenu}
              className="text-gray-700 hover:text-gray-900 flex items-center text-sm"
            >
              ÜRÜNLER
            </button>

            {/* Dropdown animation */}
            <AnimatePresence>
              {isSystemsMenuOpen && (
                <motion.div
                  initial={{ opacity: 0, y: -20, height: 0 }} // Start with no height
                  animate={{ opacity: 1, y: 0, height: 'auto' }} // Expand the height smoothly
                  exit={{ opacity: 0, y: -20, height: 0 }} // Contract the height on exit
                  transition={{ duration: 0.3 }} // Transition duration for smooth opening/closing
                  className=" bg-white shadow-md rounded-md mt-2 w-full"
                >
                  <ul className="px-2">
                    {ProductsData.map((category, index) => (
                      <li key={category.categoryUrl}>
                        <Link
                          to={`/products/${category.categoryUrl}`}
                          onClick={() => toggleCategory(index)} // Kategori aç/kapat
                          className={`flex justify-between w-full text-left text-lg text-gray-700 hover:text-gray-800 ${isActive(`/urunler/${category.categoryUrl}`)}`}
                        >
                          {category.categoryName}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          {/* <a href='/images/pdf/katalog.pdf' target='_blank' className=' text-sm' >KATOLOG</a> */}
          <Link to="/iletisim" className={`${isActive('/iletisim')} text-sm`}>İLETİŞİM</Link>
    
        </div>
      </nav>
    </header>
  );
};

export default HeaderDeskop;
